import moment from 'moment';
import { unserialize } from 'php-serialize';
import CONSTANTS from '../constants';
import CartService from '../services/CartService';
import LocationService from '../services/LocationService';
import GoogleHelper from './GoogleHelper';
import TimeHelper from './TimeHelper';
import ViewHelper from './ViewHelper';

export default class OrderType {
  static getOrderType(orderTypes, orderType) {
    if (orderTypes.length === 0) return { order_type: orderType }; // When order type is already present
    return orderTypes.find((ot) => ot.id === orderType);
  }

  static getActiveOrderType(orderTypes, orderType) {
    if (orderTypes.length === 0) return { order_type: orderType }; // When order type is already present
    return orderTypes.find((ot) => ot.id === orderType && ot.active);
  }

  static isDineIn(orderTypes, orderTypeId) {
    let orderType = this.getOrderType(orderTypes, orderTypeId);
    return orderType && orderType.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DINE_IN;
  }

  static isDelivery(orderTypes, orderTypeId) {
    let orderType = this.getOrderType(orderTypes, orderTypeId);
    return orderType && orderType.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY;
  }

  static isPickup(orderTypes, orderTypeId) {
    let orderType = this.getOrderType(orderTypes, orderTypeId);
    return orderType && orderType.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.PICK_UP;
  }

  static isCurbsidePickup(orderTypes, orderTypeId) {
    let orderType = this.getOrderType(orderTypes, orderTypeId);
    return (
      orderType && orderType.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.CURBSIDE_PICKUP
    );
  }

  static isPreDelivery(orderTypes, orderTypeId) {
    let orderType = this.getOrderType(orderTypes, orderTypeId);
    if (orderType && orderType.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY) {
      return orderType.pre_payment;
    }
    return false;
  }

  static isPreDineIn(orderTypes, orderTypeId) {
    let orderType = this.getOrderType(orderTypes, orderTypeId);
    if (orderType && orderType.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DINE_IN) {
      return orderType.pre_payment;
    }
    return false;
  }

  static isPreCurbsidePickup(orderTypes, orderTypeId) {
    let orderType = this.getOrderType(orderTypes, orderTypeId);
    if (orderType && orderType.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.CURBSIDE_PICKUP) {
      return orderType.pre_payment;
    }
    return false;
  }
  static isPrePickup(orderTypes, orderTypeId) {
    let orderType = this.getOrderType(orderTypes, orderTypeId);
    if (orderType && orderType.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.PICK_UP) {
      return orderType.pre_payment;
    }
    return false;
  }

  static getOrderData(orderTypes, orderData) {
    if (this.isDineIn(orderTypes, orderData.order_type_id)) {
      const { comment, order_type_id, order_time, order_date } = orderData;
      return { comment, order_type_id, order_time, order_date };
    }
    if (this.isDelivery(orderTypes, orderData.order_type_id)) {
      const {
        comment,
        order_type_id,
        order_time,
        order_date,
        delivery_location,
        delivery_address,
        delivery_phone,
        selectedLocation,
      } = orderData;
      return {
        comment,
        order_type_id,
        order_time,
        order_date,
        delivery_location,
        delivery_address,
        delivery_phone,
        address_id: selectedLocation ? selectedLocation.id : null
      };
    }
    if (this.isPickup(orderTypes, orderData.order_type_id)) {
      const { comment, order_type_id, order_time, order_date, delivery_phone } = orderData;
      return { comment, order_type_id, order_time, order_date, delivery_phone };
    }
    if (this.isCurbsidePickup(orderTypes, orderData.order_type_id)) {
      const {
        comment,
        order_type_id,
        order_time,
        order_date,
        delivery_phone,
        car_number,
        car_model
      } = orderData;
      return {
        comment,
        order_type_id,
        order_time,
        order_date,
        delivery_phone,
        car_number,
        car_model
      };
    }
  }

  static getDeliveryFieldsErrors(orderData) {
    let errors = [];
    // if (!orderData.delivery_location) errors.push({ type: 'delivery_location', message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.REQUIRED.DELIVERY_LOCATION });
    //if (!orderData.delivery_address) errors.push({ type: 'delivery_address', message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.REQUIRED.DELIVERY_ADDRESS });
    if (!orderData.delivery_phone)
      errors.push({
        type: 'delivery_phone',
        message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.REQUIRED.DELIVERY_PHONE
      });
    // if (orderData.delivery_phone) {
    //   let pattern = new RegExp(/^[0-9\b]+$/);
    //   if (!pattern.test(orderData.delivery_phone) && orderData.delivery_phone.length > 10) {
    //     errors.push({ type: 'delivery_phone', message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.REQUIRED.DELIVERY_CORRECT_PHONE });
    //   }
    // }

    return errors;
  }

  static getPickupFieldsErrors(orderData) {
    let errors = [];
    if (!orderData.delivery_phone)
      errors.push({
        type: 'delivery_phone',
        message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.REQUIRED.DELIVERY_PHONE
      });
    return errors;
  }

  static getCurbsidePickupFieldsErrors(orderData) {
    let errors = [];
    if (!orderData.delivery_phone)
      errors.push({
        type: 'delivery_phone',
        message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.REQUIRED.DELIVERY_PHONE
      });
    if (!orderData.car_number)
      errors.push({
        type: 'car_number',
        message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.REQUIRED.CAR_NUMBER
      });
    if (!orderData.car_model)
      errors.push({
        type: 'car_model',
        message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.REQUIRED.CAR_MODEL
      });
    return errors;
  }

  static getMinimumAmountError(orderTotal, minimumOrder, currency) {
    let errors = [];
    let minimumAmount = ViewHelper.toCurrency(minimumOrder, currency);
    if (orderTotal < parseFloat(minimumOrder))
      errors.push({
        type: 'order_total',
        message: CONSTANTS.ERRORS.MINIMUM_ORDER_ERROR(minimumAmount)
      });

    return errors;
  }

  static getAllowedOrderTypes(outlets) {
    if (!outlets) return {};

    const allowedOrderTypes = {};
    let added = false;
    for (let i = 0; i < outlets.length; i++) {
      const out = outlets[i];
      let orderTypes = out.orderTypes ? out.orderTypes : out.OrderTypes;
      for (let j = 0; j < orderTypes.length; j++) {
        allowedOrderTypes[orderTypes[j].order_type] = true;
        added = true;
      }
    }
    return added ? allowedOrderTypes : null;
  }

  static checkIfOrderTypeAllowed(orderData, orderTypes, outlets) {
    const allowedTypes = this.getAllowedOrderTypes(outlets);
    const orderType = this.getOrderType(orderTypes, orderData.order_type_id);
    if (allowedTypes[orderType.order_type]) return true;
    return false;
  }

  static checkIfOrderTypeAllowedForSelectedOutlet(orderTypes, orderData) {
    const allowedTypes = this.getAllowedOrderTypes([orderData.selectedOutlet]);
    if (allowedTypes) {
      const orderType = this.getOrderType(orderTypes, orderData.order_type_id);
      if (orderType && allowedTypes[orderType.order_type]) {
        return true;
      }
    }
    return false;
  }

  static validateAdvAsapTimings(location, orderData) {
    if (location && orderData) {
      let { orderTypes, workingHours } = location;

      let orderType = this.getOrderType(orderTypes, orderData.order_type_id);
      let options = location ? unserialize(location.options) : [];
      let events = options && options.opening_hours ? options.opening_hours.events : [];
      let event_holidays =
        options && options.opening_hours ? options.opening_hours.event_holidays : [];
      let date = moment();

      let restaurantTimings = [];

      restaurantTimings = TimeHelper.getRestaurantTimingsFor(workingHours, date, orderType ? orderType.order_type : orderTypes[0].order_type, { events, event_holidays });
      // let selectedTime = TimeHelper.getDateFromTimeOption(
      //   orderData.order_date,
      //   orderData.order_time
      // );
      if (restaurantTimings.length !== 0) {
        let selectedDateTime = moment(`${orderData.order_date} ${orderData.order_time}`, "YYYY-MM-DD HH:mm:ss");
        let timeAllowed = false; // Default to false, meaning the time is not allowed unless proven otherwise

        restaurantTimings.forEach(timing => {
          let startDateTime = moment(`${orderData.order_date} ${timing.startTime}`, "YYYY-MM-DD HH:mm:ss");
          let endDateTime = moment(`${orderData.order_date} ${timing.endTime}`, "YYYY-MM-DD HH:mm:ss");

          if (selectedDateTime.isBetween(startDateTime, endDateTime, null, '[]')) {
            timeAllowed = true; // Time is allowed
          }
        });

        return timeAllowed; // Return true if time is allowed, otherwise false
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  static async validateOrder(location, orderData, needFieldsError = true, needMinimum = true) {
    let { orderTypes, workingHours, deliveryAreas, SpecialEvents } = location;
    let errors = [];

    if (orderData.order_type_id) {
      let orderType = this.getOrderType(orderTypes, orderData.order_type_id);

      let orderActiveType = this.getActiveOrderType(orderTypes, orderData.order_type_id);
      let isReward = localStorage.getItem('isRewardOrder');
      let minimumOrder = this.getMinimumOrderFor(
        location.orderTypes,
        CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY
      )
      let options = location ? unserialize(location.options) : [];
      let events = options && options.opening_hours ? options.opening_hours.events : [];
      let event_holidays =
        options && options.opening_hours ? options.opening_hours.event_holidays : [];

      let timeData = await LocationService.fetchServerTime();
      let date = TimeHelper.convertServerTimeToUserTime(timeData.serverTime);

      let restaurantTimings = [];
      restaurantTimings = TimeHelper.getRestaurantTimingsFor(location.workingHours, date, orderType ? orderType.order_type : orderTypes[0].order_type, { events, event_holidays });
      let selectedTime = TimeHelper.getDateFromTimeOption(
        orderData.order_date,
        orderData.order_time
      );
      if (restaurantTimings.length !== 0) {
        let currentTime = location.is_adv_ordering === 1 ? moment.utc(selectedTime).subtract(5, 'minutes') : moment.utc();
        let timeNotAllowed = true; // Default to true, meaning the time is not allowed unless proven otherwise
        if (restaurantTimings.some(timing => {
          const currentTimeInMinutes = currentTime.hours() * 60 + currentTime.minutes();
          const startTimeInMinutes = timing.startTime.hours() * 60 + timing.startTime.minutes();
          const endTimeInMinutes = timing.endTime.hours() * 60 + timing.endTime.minutes();

          return currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes;
        })) {
          timeNotAllowed = false;
        }

        if (timeNotAllowed) {
          errors.push({ type: 'order_time', message: CONSTANTS.ERRORS.TIME_NOT_ALLOWED(location.name, orderType ? orderType.label : orderTypes[0].order_type, location.is_adv_ordering) });
        }

      } else {
        if (location.is_adv_ordering === 0) {
          errors.push({ type: 'order_time', message: CONSTANTS.ERRORS.CLOSED(location.name) });
        } else {
          errors.push({ type: 'order_time', message: CONSTANTS.ERRORS.CLOSED_ADV(location.name) });
        }
      }
      if (!orderActiveType) {
        errors.push({ type: 'order_type_id', message: CONSTANTS.ERRORS.ORDER_TYPE });
      }
      if (this.isDelivery(orderTypes, orderData.order_type_id)) {
        let orderTotal = CartService.getOrderTotal(location.loc_id, location.tax_percent);
        if (deliveryAreas && deliveryAreas.length > 0) {
          if (orderData.delivery_location) {
            let area = GoogleHelper.getDeliveryArea(
              orderData.delivery_location,
              deliveryAreas,
              orderTotal
            );

            if (needMinimum) {
              if (isReward === 'false' || isReward === null) {
                if (area)
                  errors = [
                    ...errors,
                    ...this.getMinimumAmountError(
                      orderTotal,
                      area.minimum_order ? area.minimum_order : minimumOrder,
                      location.currency
                    )
                  ];
                else
                  errors.push({
                    type: 'delivery_location',
                    message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.NOT_ALLOWED.DELIVERY_LOCATION(
                      location.name
                    )
                  });
              }
            } else {
              if (!area) {
                errors.push({
                  type: 'delivery_location',
                  message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.NOT_ALLOWED.DELIVERY_LOCATION(
                    location.name
                  )
                });
              }
            }
          } else {
            errors.push({
              type: 'delivery_location',
              message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.NOT_ALLOWED.DELIVERY_LOCATION(
                location.name
              )
            });
          }
        } else {
          errors.push({ type: 'delivery_location', message: CONSTANTS.ERRORS.ADDITIONAL_FIELDS.NOT_ALLOWED.NO_DELIVERY_LOCATION(location.name) });
          errors = [
            ...errors,
            ...this.getMinimumAmountError(orderTotal, orderType.minimum_order, location.currency)
          ];
        }
        if (needFieldsError) {
          let deliveryErrors = this.getDeliveryFieldsErrors(orderData);
          errors = [...errors, ...deliveryErrors];
        }
      } else if (this.isPickup(orderTypes, orderData.order_type_id)) {
        let orderTotal = CartService.getOrderTotal(location.loc_id, location.tax_percent);
        errors = [
          ...errors,
          ...this.getMinimumAmountError(orderTotal, orderType.minimum_order, location.currency)
        ];
      } else if (this.isDineIn(orderTypes, orderData.order_type_id)) {
        let orderTotal = CartService.getOrderTotal(location.loc_id, location.tax_percent);
        errors = [
          ...errors,
          ...this.getMinimumAmountError(orderTotal, orderType.minimum_order, location.currency)
        ];
      } else if (this.isCurbsidePickup(orderTypes, orderData.order_type_id)) {
        let orderTotal = CartService.getOrderTotal(location.loc_id, location.tax_percent);
        errors = [
          ...errors,
          ...this.getMinimumAmountError(orderTotal, orderType.minimum_order, location.currency)
        ];
      }

      if (needFieldsError && this.isPickup(orderTypes, orderData.order_type_id)) {
        let pickupErrors = this.getPickupFieldsErrors(orderData);
        errors = [...errors, ...pickupErrors];
      }

      if (needFieldsError && this.isCurbsidePickup(orderTypes, orderData.order_type_id)) {
        let curbsidePickupErrors = this.getCurbsidePickupFieldsErrors(orderData);
        errors = [...errors, ...curbsidePickupErrors];
      }
    } else {
      errors.push({ type: 'order_type_id', message: 'Please select an order type' });
    }

    return { enableSubmit: errors.length === 0, showErrors: errors.length !== 0, errors };
  }

  static getError(errors, type) {
    return errors.find((error) => error.type === type);
  }

  static getMinimumOrderFor(orderTypes, type) {
    let orderType = orderTypes.find((ot) => ot.order_type === type);
    if (orderType) return parseFloat(orderType.minimum_order);
  }

  static pickupOutlets(outlets) {
    let filterOutlets = [];
    if (outlets.length > 0) {
      outlets.map((item) => {
        let outlet = item.orderTypes.find(
          (ot) => ot.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.PICK_UP
        );
        if (outlet) {
          filterOutlets.push(item);
        }
      });
    }
    return filterOutlets;
  }
  static dineinOutlets(outlets) {
    let filterOutlets = [];
    if (outlets.length > 0) {
      outlets.map((item) => {
        let outlet = item.orderTypes.find(
          (ot) => ot.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DINE_IN
        );
        if (outlet) {
          filterOutlets.push(item);
        }
      });
    }
    return filterOutlets;
  }
  static curbsideOutlets(outlets) {
    let filterOutlets = [];
    if (outlets.length > 0) {
      outlets.map((item) => {
        let outlet = item.orderTypes.find(
          (ot) => ot.order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.CURBSIDE_PICKUP
        );
        if (outlet) {
          filterOutlets.push(item);
        }
      });
    }
    return filterOutlets;
  }

  static pickOutletsFor(orderTypes, currentType, outlets) {
    const type = this.getOrderType(orderTypes, currentType);
    if (!type) return [];
    let filterOutlets = [];
    if (outlets.length > 0) {
      outlets.map((item) => {
        let outlet = item.orderTypes.find((ot) => ot.order_type === type.order_type);
        if (outlet) {
          filterOutlets.push(item);
        }
      });
    }
    return filterOutlets;
  }

  static pickOrderTimeFor(orderTypes, currentType) {
    if (this.isPickup(orderTypes, currentType)) {
      return { title: 'When would you like to takeaway?', label: 'Pickup', isNow: true };
    } else if (this.isDelivery(orderTypes, currentType)) {
      return { title: 'When would you like it delivered?', label: 'Deliver', isNow: true };
    } else if (this.isDineIn(orderTypes, currentType)) {
      return { title: 'When would you like to dine in?', label: 'DineIn', isNow: true };
    } else if (this.isCurbsidePickup(orderTypes, currentType)) {
      return { title: 'When would you like this curbside order?', label: 'Curbside', isNow: true };
    } else {
      return { title: 'Order Time', type: '', isNow: false };
    }
  }

  static sortOrderTypes(orderTypes) {
    let sortedTypes = orderTypes.sort(this.sortFunc);
    return sortedTypes;
  }

  static sortFunc(a, b) {
    let sortingArr = ['delivery', 'pick_up', 'dine_in', 'curbside_pickup'];
    return sortingArr.indexOf(a.order_type) - sortingArr.indexOf(b.order_type);
  }
}